<template>
  <v-toolbar
    data-js="get-height"
    class="toolbar--white action-bar overflow--y get-height"
    :class="{ 'action-bar--ml': !mainMenuIsOpen }"
    flat
  >
    <Breadcrumb :routes="breadcrumbItems" />

    <v-layout v-if="Boolean(selectedCompany) && !selectedItems.length" align-center row>
      <v-spacer />

      <span v-if="claims.employee['ROLE_GET_EMPLOYEE_EXPORT'] && isValidArray(items)">
        <ExportEmployeesAction
          v-if="isValidObject(selectedCompany)"
          :search="filters.search"
        />

        <span v-else>
          <v-tooltip min-width="160" max-width="160" top>
            <a href="#" class="action-bar__link" slot="activator" @click.prevent>
              {{ $t(`${namespace}.export`) }}
            </a>
            {{ $t('Common.selectCompany') }}
          </v-tooltip>
        </span>
      </span>

      <span v-if="
        claims.company['ROLE_POST_COMPANY_ID_EMPLOYEE_BATCHUPDATE'] &&
        claims.company['ROLE_POST_COMPANY_COMPANYID_BULKOPERATION_ID_EXECUTE']
      ">
        <BulkActions
          v-if="
            ($route.name === 'CompanyDetail' && $route.params.id) ||
            isValidObject(selectedCompany)
          "
          @reloadData="$emit('reloadData')"
        />

        <span v-else>
          <v-tooltip min-width="160" max-width="160" top>
            <a href="#" class="action-bar__link" slot="activator" @click.prevent>
              {{ $t('Common.bulkImport') }}
            </a>
            {{ $t('Common.selectCompany') }}
          </v-tooltip>
        </span>
      </span>

      <v-btn
        v-if="claims.employee['ROLE_POST_EMPLOYEE']"
        :to="{ name: 'Employee', params: { type: 'cadastrar' } }"
        color="accent"
        class="action-bar__btn"
        round
        depressed
      >
        {{ $t(`${namespace}.newEmployee`) }}
      </v-btn>
    </v-layout>

    <v-layout v-if="Boolean(selectedCompany) && selectedItems.length" align-center row>
      <v-spacer />

      <a
        href="#"
        :title="$t('Common.clear')"
        class="action-bar__link mr-2"
        @click.prevent="handleClearSelectedItems"
      >{{ $t('Common.clear') }}</a>

      <a
        v-if="claims.company['ROLE_DELETE_COMPANY_ID_EMPLOYEES']"
        href="#"
        title=""
        class="action-bar__link mr-2"
        @click.prevent="handleDeleteItems"
      >{{ $t(`${namespace}.deleteSelectedEmployees`) }}</a>
    </v-layout>
  </v-toolbar>
</template>

<script>
import { mapState } from 'vuex'
import { isObject, isArray } from 'utils/functions'
import Breadcrumb from 'components/Breadcrumb'
import ExportEmployeesAction from 'components/employees/ExportEmployeesAction'
import BulkActions from 'components/employees/BulkActions'

export default {
  name: 'ActionBar',
  props: {
    filters: {
      type: Object
    },
    items: {
      type: Array,
      required: true
    },
    selectedItems: {
      type: Array,
      required: true
    }
  },
  components: {
    Breadcrumb,
    ExportEmployeesAction,
    BulkActions
  },
  computed: {
    ...mapState({
      selectedCompany: ({ company }) => company.selectedCompany,
      mainMenuIsOpen: ({ mainMenu }) => mainMenu.isOpen,
      claims: ({ userClaims }) => userClaims.claims
    })
  },
  data () {
    return {
      namespace: 'Views.EmployeesPage',
      breadcrumbItems: [
        { name: 'Employees', title: this.$t('Views.EmployeesPage.title') }
      ]
    }
  },
  methods: {
    isValidObject (val) {
      return isObject(val)
    },

    isValidArray (val) {
      return isArray(val)
    },

    change (val) {
      this.$emit('change')
    },

    handleClearSelectedItems () {
      this.$emit('clearSelectedItems')
    },

    handleDeleteItems () {
      this.$emit('deleteItems', this.selectedItems)
    }
  }
}
</script>
